import { Component } from "@angular/core";
import { airQuoteHistoryService } from "../airQuoteHistory/airQuoteHistory.service";
import { FormControl, FormGroup, FormBuilder } from "@angular/forms";
import { Constants } from "../constants/constants"
import { ActivatedRoute } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";


@Component({
    selector: "AirQuoteTraffic",
    templateUrl: "/app/airQuoteTraffic/AirQuoteTraffic.html",
    providers: [airQuoteHistoryService]
})

export class AirQuoteTrafficComponent {

    trafficQuotes = [] as Array<IAirQuoteHistoryModel>;
    trafficHistory = [] as Array<IAirQuoteHistoryModel>;
    trafficTracking = [] as Array<IAirQuoteHistoryModel>;
    filter = new FormControl();
    search = "";
    lastSortedColumnQuote = "id";
    lastSortedColumnHistory = "id";
    isDescQuote = true;
    isDescHistory = true;
    lastSortedColumnTracking = "id";
    isDescTracking = true;

    trafficQuotesRowCount = 0;
    trafficQuotesPageSize = 20;
    trafficQuotesPageNumber = 1;
    
    trafficTrackingRowCount = 0;
    trafficTrackingPageSize = 20;
    trafficTrackingPageNumber = 1;

    trafficHistoryRowCount = 0;
    trafficHistoryPageSize = 20;
    trafficHistoryPageNumber = 1;

    restUrl = Constants.attachtmentsUrl;

    quotesFormGroup: FormGroup;
    quoteDetailToAdd = {} as IAirQuoteDetails;
    quoteDetails = [] as Array<IAirQuoteDetails>;


    constructor(private quoteHistoryService: airQuoteHistoryService, private formBuilder: FormBuilder, private constants: Constants, private activatedRoute: ActivatedRoute) { }

    ngOnInit() {

        
        this.buildValidationGroups();
        this.addQuote();

        this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

        this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
            if (term) {
                this.searchTrafficQuotes(term, 1);
                this.searchTrafficHistory(term, 1);
                this.searchTrafficTracking(term, 1);
            } else {
                this.getTrafficQuotes();
                this.getTrafficHistory();
                this.getTrafficTracking();
            }
        });
    }

    searchTrafficQuotes(term: string, pageNumber: number): void {        
        if (term) {
            this.quoteHistoryService.getTrafficQuotesPendingSearch(this.constants.user.email, this.trafficHistoryPageNumber, this.trafficQuotesPageSize, term).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (trafficQuotes) {                    
                    this.trafficQuotes = trafficQuotes.quotes;
                    this.trafficQuotesRowCount = trafficQuotes.rowCount;
                    this.trafficQuotesPageNumber = pageNumber;
                }
            });
        }
    }

    searchTrafficHistory(term: string, pageNumber: number): void {
        if (term) {
            this.quoteHistoryService.getTrafficPendingTrafficSelectionSearch(this.constants.user.email, this.trafficHistoryPageNumber, this.trafficQuotesPageSize, term).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (trafficQuotes) {                    
                    this.trafficTracking = trafficQuotes.quotes;
                    this.trafficQuotesRowCount = trafficQuotes.rowCount;
                    this.trafficQuotesPageNumber = pageNumber;
                }
            });
        }
    }

    searchTrafficTracking(term: string, pageNumber: number): void {
        if (term) {
            this.quoteHistoryService.getTrafficCompletedQuotesSearch(this.constants.user.email, this.trafficTrackingPageNumber, this.trafficTrackingPageSize, term).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (trafficQuotes) {
                    this.trafficHistory = trafficQuotes.quotes;
                    this.trafficTrackingRowCount = trafficQuotes.rowCount;
                    this.trafficTrackingPageNumber = pageNumber;                    
                }
            });
        }
    }

    getTrafficQuotes(): void {
        if (this.search && this.search.length > 0) {
            this.searchTrafficQuotes(this.search, this.trafficQuotesPageNumber);
        }
        else {
            this.quoteHistoryService.getTrafficQuotesPending(this.constants.user.email, this.trafficQuotesPageNumber, this.trafficQuotesPageSize).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {                
                if (trafficQuotes) {                           
                    this.trafficQuotes = trafficQuotes.quotes;
                    this.trafficQuotesRowCount = trafficQuotes.rowCount;                                      
                }
            });
        }     
    }

    getTrafficHistory(): void {        
        if (this.search && this.search.length > 0) {
            this.searchTrafficQuotes(this.search, this.trafficHistoryPageNumber);
        }
        else {
            this.quoteHistoryService.getTrafficCompletedQuotes(this.constants.user.email, this.trafficHistoryPageNumber, this.trafficHistoryPageSize).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (trafficQuotes) {
                    this.trafficHistory = trafficQuotes.quotes;
                    this.trafficHistoryRowCount = trafficQuotes.rowCount;
                }
            });
        } 
    }

    getTrafficTracking(): void {    
        if (this.search && this.search.length > 0) {
            this.searchTrafficQuotes(this.search, this.trafficTrackingPageNumber);
        }
        else {
            this.quoteHistoryService.getTrafficPendingTrafficSelection(this.constants.user.email, this.trafficTrackingPageNumber, this.trafficTrackingPageSize).subscribe((trafficQuotes: { quotes: Array<IAirQuoteHistoryModel>, rowCount: number }): void => {
                if (trafficQuotes) { 
                    this.trafficTracking = trafficQuotes.quotes;
                    this.trafficTrackingRowCount = trafficQuotes.rowCount;                    
                }
            });
        }        
    }

    showApprovalArrows(column: string): boolean {
        return this.isDescQuote && this.lastSortedColumnQuote === column;
    }

    setSortOrderApproval(columnName: string): void {
        if (this.lastSortedColumnQuote === columnName)
            this.isDescQuote = !this.isDescQuote;
        else
            this.isDescQuote = true;

        this.lastSortedColumnQuote = columnName;
    }

    showHistoryArrows(column: string): boolean {
        return this.isDescHistory && this.lastSortedColumnHistory === column;
    }

    setSortOrderHistory(columnName: string) {
        if (this.lastSortedColumnHistory === columnName)
            this.isDescHistory = !this.isDescHistory;
        else
            this.isDescHistory = true;

        this.lastSortedColumnHistory = columnName;
    }

    showTrackingArrows(column: string): boolean {
        return this.isDescTracking && this.lastSortedColumnTracking === column;
    }

    setSortOrderTracking(columnName: string) {
        if (this.lastSortedColumnTracking === columnName)
            this.isDescTracking = !this.isDescTracking;
        else
            this.isDescTracking = true;

        this.lastSortedColumnTracking = columnName;
    }

    showHideDetails(quote: IAirQuoteHistoryModel): void {
        if (quote.isVisible === undefined)
            quote.isVisible = false;
        quote.isVisible = !quote.isVisible;
    }

    addQuote(): void {
        if (!this.quotesFormGroup.valid)
            return;

        let quoteDetailToAdd = <IAirQuoteDetails>
            {
                id: 0,
                quoteId: 0,
                method: "",
                cost: 0,                             
                trackingNum: "",
                selected:false
            };

        this.quoteDetails.push(quoteDetailToAdd);
    }

    buildValidationGroups(): void {

        this.quotesFormGroup = this.formBuilder.group({
            id: 0,
            quoteId: 0,
            method: "",
            cost: 0,            
            trackingNum: "",
            selected:false
        });
    }
    downloadAttachment(formTypeId:number,approvalId: number,fileName: string)
	{
		this.quoteHistoryService.downloadAttachment(formTypeId,approvalId,fileName).subscribe((blob) => {
			const link = document.createElement('a');
			const url = window.URL.createObjectURL(blob);
			link.href = url;
			link.download = fileName;
			link.click();
			window.URL.revokeObjectURL(url);
		  });
	}
}